export default "__VITE_ASSET__8J2a$l_X__"